"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumHelper = exports.EnumHelper = void 0;
var EnumHelper = /** @class */ (function () {
    function EnumHelper() {
    }
    EnumHelper.prototype.getAllNames = function (T) {
        var enumNames = [];
        for (var key in T) {
            if (T.hasOwnProperty(key)) {
                enumNames.push(key);
            }
        }
        return enumNames;
    };
    EnumHelper.prototype.getAllValues = function (T) {
        var allEnumValues = Object.keys(T).map(function (key) { return T[key]; });
        return allEnumValues;
    };
    EnumHelper.prototype.getEnumFromValue = function (T, value) {
        try {
            if (!value) {
                return undefined;
            }
            // we can map back from index number directly
            if (this.isNumeric(value)) {
                return T[value];
            }
            // for strings, we need to compare each value separately
            var allEnumValues = this.getAllValues(T);
            var result = allEnumValues.find(function (m) { return m.toLowerCase() === value.toString().toLowerCase(); });
            if (!result) {
                return undefined;
            }
            return result;
        }
        catch (err) {
            return undefined;
        }
    };
    EnumHelper.prototype.getEnumFromName = function (T, name) {
        var e_1, _a;
        var allNames = this.getAllNames(T);
        try {
            for (var allNames_1 = __values(allNames), allNames_1_1 = allNames_1.next(); !allNames_1_1.done; allNames_1_1 = allNames_1.next()) {
                var enumName = allNames_1_1.value;
                if (enumName.toLowerCase() === name.toLowerCase()) {
                    return T[enumName];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (allNames_1_1 && !allNames_1_1.done && (_a = allNames_1.return)) _a.call(allNames_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return undefined;
    };
    EnumHelper.prototype.isNumeric = function (value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    };
    return EnumHelper;
}());
exports.EnumHelper = EnumHelper;
exports.enumHelper = new EnumHelper();
//# sourceMappingURL=enum.helper.js.map